<template>
  <v-row justify="center">
    <v-dialog
      v-model="mostrar"
      max-width="290"
      class="dialog"
      @click:outside="update"
    >
      <v-card>
        <v-card-title class="title">Registro ExpoPóster</v-card-title>

        <v-card-text class="center text">
          Usted está por registrarse en ExpoPóster, puede continuar con el
          registro como participante o si está interesado en colaborar con el
          evento puede postularse como evaluador
        </v-card-text>

        <v-card-actions class="center margin">
          <v-col class="center">
            <v-btn
              class="btn-eva"
              color="#05519c"
              outlined
              @click="$router.push('/registro')"
            >
              Evaluador
            </v-btn>
          </v-col>
          <v-col>
            <v-btn class="btn-par" outlined @click="$router.push('/registro')">
              Participante
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ['mostrar'],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    update() {
      this.$emit('update', this.dialog)
    },
  },
}
</script>

<style>
.center {
  align-content: center;
  justify-content: center;
  text-align: center;
}

.btn-par {
  color: #05519c !important;
}

.margin {
  display: inline;
}

.title {
  word-break: keep-all !important;
  align-content: center;
  justify-content: center;
  text-align: center;
}

.text {
  font-size: 16px;
}

.dialog {
  border: solid black 2px !important;
}
</style>
